export interface NamedEntity {
    id: number;
    name: string;
}

export const NamedEntityDefault = {
    id: 1,
    name: "-"
};